



































































import mixins from 'vue-typed-mixins'
import layoutMixin from '../layoutMixin'
import routeMixin from '@/router/routeMixin'
import Openable from '@/global/viewmodels/openable'

export default mixins(layoutMixin, routeMixin).extend({
    props: {
        source: String
    },
    components: {
        SideBar: () => import('./SideBar.vue')
    },
    data: () => ({
        cacheSize: '',
        drawer: new Openable()
    })
})
